// COLDFIRE ATC v3 — single source of truth for all CF add-to-cart
// Handles: #cf-atc-form (belt hero) + .cf-upsell__atc (upsell grid)

document.addEventListener('DOMContentLoaded', function() {

  function updateCartCount(n) {
    document.querySelectorAll('cart-count').forEach(function(el) {
      el.textContent = n;
      if (n > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }

  function refreshDrawer() {
    // Concept theme cart:refresh with delay so cart state settles first
    setTimeout(function() {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
    }, 200);
  }

  function cfFetch(variantId, quantity, onSuccess, onError) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: parseInt(quantity) || 1 })
    })
    .then(function(r) {
      return r.json().then(function(d) { return { ok: r.ok, data: d }; });
    })
    .then(function(res) {
      if (!res.ok) throw new Error(res.data.description || 'Error');
      return fetch('/cart.js').then(function(r) { return r.json(); });
    })
    .then(function(cart) {
      updateCartCount(cart.item_count);
      refreshDrawer();
      if (onSuccess) onSuccess(cart);
    })
    .catch(function(err) {
      console.warn('[CF ATC]', err.message);
      if (onError) onError(err);
    });
  }

  // ── BELT HERO ─────────────────────────────────────────────────
  var form = document.getElementById('cf-atc-form');
  var atcBtn = document.getElementById('cf-atc-btn');
  var atcText = document.getElementById('cf-atc-text');

  if (form && atcBtn) {
    var defaultLabel = atcText ? atcText.textContent.trim() : 'Add to Cart';

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (atcBtn.disabled) return;

      var vid = document.getElementById('cf-variant-id');
      var qty = document.getElementById('cf-qty-hidden');
      if (!vid || !vid.value) return;

      atcBtn.disabled = true;
      if (atcText) atcText.textContent = 'Adding...';

      cfFetch(
        vid.value,
        qty ? qty.value : 1,
        function() {
          if (atcText) atcText.textContent = 'Added';
          setTimeout(function() {
            atcBtn.disabled = false;
            if (atcText) atcText.textContent = defaultLabel;
          }, 1800);
        },
        function() {
          if (atcText) atcText.textContent = 'Error';
          atcBtn.disabled = false;
          setTimeout(function() {
            if (atcText) atcText.textContent = defaultLabel;
          }, 3000);
        }
      );
    });
  }

  // ── UPSELL GRID ───────────────────────────────────────────────
  document.querySelectorAll('.cf-upsell__atc').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var vid = btn.dataset.variantId;
      if (!vid || btn.disabled) return;

      btn.disabled = true;
      var span = btn.querySelector('.cf-upsell__atc-text');
      if (span) span.textContent = 'Adding...';

      cfFetch(
        vid,
        1,
        function() {
          btn.classList.add('is-added');
          if (span) span.textContent = 'Added';
        },
        function() {
          btn.classList.add('is-error');
          btn.disabled = false;
          if (span) span.textContent = 'Error';
          setTimeout(function() {
            btn.classList.remove('is-error');
            if (span) span.textContent = 'Add to Cart';
          }, 2000);
        }
      );
    }, true); // useCapture=true — catches event before Concept theme
  });

});